import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import type { DiagnoseCreateInput } from '../../../../graphql/generated/graphql.ts';
import type { Diagnose } from '../Diagnoses.tsx';
import { CREATE_DIAGNOSE_MUTATION } from './CreateDiagnoseModal.gql';
import { DiagnoseForm } from './DiagnoseForm';

export const CreateDiagnoseModal: React.FC<{
  labId: string;
  diagnoses: Diagnose[];
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}> = ({ labId, diagnoses, open, onClose, onSuccess }) => {
  const [createDiagnoseMutation, { loading }] = useMutation(CREATE_DIAGNOSE_MUTATION);
  const [form] = useForm<DiagnoseCreateInput>();
  const { message } = App.useApp();

  const create = async (values: DiagnoseCreateInput) => {
    try {
      await createDiagnoseMutation({
        variables: {
          input: {
            ...values,
            labId: labId,
          },
        },
      });

      message.success('Diagnose wurde erstellt');
      onSuccess();
      closeAndReset();
    } catch (_e) {
      message.error('Diagnose konnte nicht erstellt werden');
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      width={768}
      title="Neue Diagnose erstellen"
      okText="Erstellen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
      open={open}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
    >
      <DiagnoseForm
        form={form}
        initialValues={{
          labId: labId,
          name: '',
          text: '',
          icd10: '',
        }}
        onFinish={values => create(values as DiagnoseCreateInput)}
        nameValidator={name => diagnoses.length === 0 || !diagnoses.some(it => it.name === name)}
      />
    </Modal>
  );
};
